import { render, staticRenderFns } from "./GenericTableDecimalCell.vue?vue&type=template&id=449fe396&scoped=true"
import script from "./GenericTableDecimalCell.vue?vue&type=script&lang=ts"
export * from "./GenericTableDecimalCell.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449fe396",
  null
  
)

export default component.exports